exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host ::ng-deep .sus-wrapper .flutter-app {\n  height: 75vh !important;\n  width: 1024px !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/layout/home/sus-feedback/sus-feedback.component.css
// module id = ../../../../../src/app/layout/home/sus-feedback/sus-feedback.component.css
// module chunks = main